import { Button } from '@themesberg/react-bootstrap';
import moment from 'moment';
import React from 'react'
import { Link } from 'react-router-dom';
import { Routes } from '../../../../routes';

export const TableRow = (props) => {
  const { value, user, game, gamePeriod, cartId, createdAt, transactionDate, status, numberRows, id, deletedAt, printedAt, deviceId, images, cartGroupId, TransactionPayReward = [] } = props;

  const detailLink = Routes.VietlottTicketDetail.path.replace(':id', id)

  const cartGroupLink = Routes.VietlottGroupDetail.path.replace(':id', cartGroupId)

  const datedString = moment(createdAt || '').format('DD/MM/YYYY HH:mm').toLocaleString()

  const transDatedString = transactionDate ? moment(transactionDate).format('DD/MM/YYYY HH:mm').toLocaleString() : ''

  const deletedDatedString = deletedAt ? moment(deletedAt || '').format('DD/MM/YYYY HH:mm').toLocaleString() : ''

  const printedDatedString = printedAt ? moment(printedAt || '').format('DD/MM/YYYY HH:mm').toLocaleString() : ''

  const isCartGroup = cartGroupId !== null

  return (
    <tr>
      <td>
        <Link to={detailLink} target="_blank">
          <Button variant="info" className="m-1">
            Chi tiết
          </Button>
        </Link>
      </td>
      {!isCartGroup && <td>{cartId}</td>}
      <td>{id}</td>
      {!isCartGroup && <td>
        {(user && user.name) || ""}<br />
        <span><strong className={`text-primary`}>{(user && user.phone) || ""}</strong></span>
      </td>}
      {isCartGroup && <td>
        <Link to={cartGroupLink} target="_blank">
          <Button variant="info" className="m-1">
            Xem nhóm
          </Button>
        </Link>
      </td>}
      <td>
        {game.name}
        <br />
        {gamePeriod.name}
        <br />
        {gamePeriod.resultDate} {game.id === 'keno' || game.id === 'lotto535' ? gamePeriod.resultTime : ''}
      </td>
      <td className="align-items-right">{new Intl.NumberFormat('vn-VI', {}).format(value) || ""}</td>
      <td>{status === 1 ? 'Đã thanh toán' : status === 2 ? 'Đang chờ in' : status === 3 ? 'Đã hoàn thành' : status === 4 ? 'Trúng thưởng' : status === 5 ? 'Không trúng' : status === 6 ? 'Đã hủy - Hoàn tiền' : status === 8 ? 'Nhân viên hủy' : status === 9 ? 'Đã in' : 'Đang chờ xử lý'}</td>
      <td>{datedString}</td>
      <td>{transDatedString}</td>
      <td>{deletedDatedString}</td>
      <td>
        {printedDatedString &&
          <>{printedDatedString}<br /></>
        }
      </td>
      <td className="text-center">
        {deviceId &&
          <b>{deviceId}</b>
        }
      </td>
    </tr>
  );
};
